import type { createCrmApiClient } from './crm-api';

export type CrmApiFactory = typeof createCrmApiClient;

/** Cache code, never clients, sessions, tokens, access decisions or record payloads. */
export function createCodeLoader<T>(load: () => Promise<T>) {
  let resolved: { value: T } | undefined;
  let pending: Promise<T> | undefined;
  return function loadCode(): Promise<T> {
    if (resolved) return Promise.resolve(resolved.value);
    if (pending) return pending;
    let deadline: ReturnType<typeof setTimeout>;
    const timeout = new Promise<never>((_resolve, reject) => {
      deadline = setTimeout(() => reject(new Error('Connection code download timed out')), 30_000);
    });
    pending = Promise.race([Promise.resolve().then(load), timeout])
      .then(
        (value) => {
          resolved = { value };
          pending = undefined;
          return value;
        },
        (error: unknown) => {
          pending = undefined;
          throw error;
        },
      )
      .finally(() => clearTimeout(deadline));
    return pending;
  };
}

export const loadCrmApiFactory = createCodeLoader(() =>
  import('./crm-api').then((module) => module.createCrmApiClient),
);
